import React from 'react';
import '../../../Styles/Layout/QuoteMarker.css';

/** Fixed-position pill; `useTextSelection` clears `isVisible` on scroll so it stays aligned with content. */
interface QuoteMarkerProps {
  x: number;
  y: number;
  onClick: () => void;
  isVisible: boolean;
}

export const QuoteMarker: React.FC<QuoteMarkerProps> = ({ x, y, onClick, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div 
      className="quote-marker"
      style={{ 
        left: x, 
        top: y - 40 // Position above the selection
      }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <span className="quote-marker-text">Add to Chat</span>
    </div>
  );
};